import type { RouteRecordRaw } from 'vue-router';
export const routes: RouteRecordRaw[] = [
  {
    path: 'new-replenishment',
    component: () => import('@/app/modules/new-replenishment/views/new-replenishment-index.vue'),
    meta: {
      layoutFeatures: {
        actionPanel: true,
      },
    },
    children: [
      {
        path: '',
        component: () =>
          import('@/app/modules/new-replenishment/views/new-replenishment-overview.vue'),
      },
    ],
  },
];
export default routes;
